module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "msc-title"
  }, [_vm._v("Manage School Info")]), _vm._v(" "), _c('edit-school-info', {
    attrs: {
      "schoolTitle": false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2206082a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/schoolInfo/adminPortalSchoolInfo.vue
// module id = 2170
// module chunks = 61